module.exports = __webpack_public_path__ + "img/safing.61e8f151.svg";